import { t } from '@/i18n/utils'

/**
 * 错误页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const errorCommonConfig = {
  texts: {
    get defaultMessage() { return t('defaultMessage') },
    get retry() { return t('Retry') },
    get home() { return t('Home') },
  },
}
